import Box from '@mui/material/Box';
import { ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  paddingX?: number | { xs?: number; sm?: number; md?: number };
  paddingY?: number | { xs?: number; sm?: number; md?: number };
  [key: string]: any;
}

const Container = ({
  children,
  maxWidth = 'lg',
  paddingX = { xs: 2, sm: 3, md: 6 },
  paddingY = { xs: 4, sm: 6, md: 8 },
  ...rest
}: ContainerProps) => (
  <Box
    maxWidth={maxWidth === false ? '100%' : maxWidth}
    width={1}
    margin='0 auto'
    paddingX={paddingX}
    paddingY={paddingY}
    {...rest}
  >
    {children}
  </Box>
);

export default Container;
